module.exports = "/images/pin-light-active.png?491158a3bffdbc64f43d06513c35b645";